import React, { useState, useEffect } from "react";
import "./AdminHomePageManage.css";
import Modal from '../../components/Modal';
const API_BASE = "https://rbuymart.rbhardwaj.com/server/api/admin/manage_home.php";

const AdminHomePageManage = () => {
  const [activeTab, setActiveTab] = useState("faqs"); // faqs | home_hero_slides | home_instagram_links | home_promo_banners
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [open, setOpen] = useState(false);
  // Form State
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  const fetchData = async (section) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}?section=${section}`);
      const result = await res.json();
      if (result.status === "success") {
        setData(result.data || []);
      }
    } catch (err) {
      alert("Error fetching data: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const resetForm = () => {
    setFormData({});
    setEditItem(null);
  };

  const handleEditClick = (item) => {
   setOpen(true);
    setEditItem(item);
    setFormData(item);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const action = editItem ? "update" : "add";

    try {
      const res = await fetch(API_BASE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          section: activeTab,
          action: action,
          data: formData,
        }),
      });
      const result = await res.json();
      if (result.status === "success") {
        alert(result.message);
        resetForm();
        fetchData(activeTab);
      } else {
        alert("Failed: " + result.message);
      }
    } catch (err) {
      alert("Submission error: " + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    try {
      const res = await fetch(API_BASE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          section: activeTab,
          action: "delete",
          data: { id },
        }),
      });
      const result = await res.json();
      if (result.status === "success") {
        alert("Deleted successfully");
        fetchData(activeTab);
      }
    } catch (err) {
      alert("Delete failed: " + err.message);
    }
  };

  return (
    <div className="admin-home-manage">
   
 <div class="admin-header-tap">
     
          <h3>Homepage Manager</h3>
        <div className="flex-div">
    <button onClick={() => setOpen(true)} className="btn-add">
       <i class="material-icons">&#xe146;</i> Add
      </button>
    <button onClick={() => window.print()} className="btn-print">
            <i className="material-icons">&#xe8ad;</i> Print
          </button>
        </div>
        </div>
      {/* Navigation Tabs */}
      <div className="tab-buttons">
        <button
          className={activeTab === "faqs" ? "active" : ""}
          onClick={() => { setActiveTab("faqs"); resetForm(); }}
        >
          FAQs
        </button>
        <button
          className={activeTab === "home_hero_slides" ? "active" : ""}
          onClick={() => { setActiveTab("home_hero_slides"); resetForm(); }}
        >
          Hero Slides
        </button>
        <button
          className={activeTab === "home_promo_banners" ? "active" : ""}
          onClick={() => { setActiveTab("home_promo_banners"); resetForm(); }}
        >
          Promo Banners
        </button>
        <button
          className={activeTab === "home_instagram_links" ? "active" : ""}
          onClick={() => { setActiveTab("home_instagram_links"); resetForm(); }}
        >
          Instagram Links
        </button>
      </div>

      {/* Dynamic Form Section */}
         <Modal
                  
              isOpen={open}
              onClose={() => setOpen(false)}
              title={activeTab}
            >
  <div className="form-card">
      
        <form onSubmit={handleSubmit}>
          {/* 1. FAQs Form */}
          {activeTab === "faqs" && (
            <>
               <div className="formlabeldiv">  
    <input
                type="text"
                name="question"
                placeholder="Question"
                value={formData.question || ""}
                onChange={handleInputChange}
                required
              />
                <label htmlFor=""></label>
               </div>

               <div className="formlabeldiv">  
     <textarea
                name="answer"
                placeholder="Answer"
                value={formData.answer || ""}
                onChange={handleInputChange}
                required
              />
                <label htmlFor=""></label>
               </div>

               <div className="formlabeldiv">  
    <input
                type="number"
                name="sort_order"
                placeholder="Sort Order"
                value={formData.sort_order ?? 0}
                onChange={handleInputChange}
              />
                <label htmlFor=""></label>
               </div>

               <div className="formlabeldiv">  
    <select
                name="status"
                value={formData.status || "active"}
                onChange={handleInputChange}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
                <label htmlFor=""></label>
               </div>
          
         
          
          
            </>
          )}

          {/* 2. Hero Slides Form */}
          {activeTab === "home_hero_slides" && (
            <>
             <div className="formlabeldiv">  
                  <input
                type="text"
                name="img"
       
                value={formData.img || ""}
                onChange={handleInputChange}
                required
              />

                <label htmlFor="">Image URL (img)</label>
            </div>
             <div className="formlabeldiv">  
                      <input
                type="text"
                name="color"
            
                value={formData.color || ""}
                onChange={handleInputChange}
              />

                <label htmlFor="">Colour</label>
            </div>

             <div className="formlabeldiv">  
                    <input
                type="text"
                name="link"
                
                value={formData.link || ""}
                onChange={handleInputChange}
              />

                <label htmlFor="">Link Target (link)</label>
            </div>

             <div className="formlabeldiv">  
                      <input
                type="number"
                name="sort_order"
              
                value={formData.sort_order ?? 0}
                onChange={handleInputChange}
              />

                <label htmlFor="">Sort Order</label>
            </div>
            
         <div className="formlabeldiv">  
    <select
                name="status"
                value={formData.status || "active"}
                onChange={handleInputChange}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>

             <label htmlFor="">Status</label>
            </div>
        
          
            </>
          )}

          {/* 3. Promo Banners Form */}
          {activeTab === "home_promo_banners" && (
            <>
               <div className="formlabeldiv">
      <select
                name="type"
                value={formData.type || "offer"}
                onChange={handleInputChange}
                required
              >
                <option value="offer">Offer Banner</option>
                <option value="deal">Deal Banner</option>
              </select>
                      <label htmlFor="">Type</label>
               </div>
        
                   <div className="formlabeldiv">
       <input
                type="text"
                name="img"
               
                value={formData.img || ""}
                onChange={handleInputChange}
                required
              />
              <label htmlFor="">Banner Image URL (img)</label>

                   </div>
          <div className="formlabeldiv">   
            <input
                type="text"
                name="link"
               
                value={formData.link || ""}
                onChange={handleInputChange}
              />
               <label htmlFor="">Link Target (link)</label>
              </div>
           <div className="formlabeldiv"> 
             <input
                type="number"
                name="sort_order"
              
                value={formData.sort_order ?? 0}
                onChange={handleInputChange}
              />
               <label htmlFor="">sort_order</label>
              </div>
            <div className="formlabeldiv"> 
                 <select
                name="status"
                value={formData.status || "active"}
                onChange={handleInputChange}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
               <label htmlFor="">status</label>
              </div>
           
            
            
            </>
          )}

          {/* 4. Instagram Links Form */}
          {activeTab === "home_instagram_links" && (
            <>
              <div className="formlabeldiv"> 
     <input
                type="text"
                name="post_code"
             
                value={formData.post_code || ""}
                onChange={handleInputChange}
                required
              />
                  <label htmlFor="">Post Code (e.g. DULx4KHEyUE)</label>
              </div>
                   <div className="formlabeldiv"> 
  <input
                type="number"
                name="sort_order"
             
                value={formData.sort_order ?? 0}
                onChange={handleInputChange}
              />
                  <label htmlFor="">Sort Order</label>
              </div>
         
            
            </>
          )}

          <div className="flex-div">
         
              {editItem ? ( <button type="submit" className="btn-update">Update</button>) : (<button type="submit" className="btn-submit ">Save</button>)}
         
            {editItem && (
              <button type="button" className="btn-cancel" onClick={resetForm}>
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

            </Modal>
    

      {/* Table Display Section */}
      <div className="data-table-container">
       
        {loading ? (
          <p>Loading...</p>
        ) : (
             <div className="table-div">
  <table>
            <thead>
              <tr>
                <th>ID</th>
                {activeTab === "faqs" && <th>Question</th>}
                {activeTab === "home_hero_slides" && (
                  <>
                    <th>Image</th>
                    <th>Color</th>
                    <th>Link</th>
                  </>
                )}
                {activeTab === "home_promo_banners" && (
                  <>
                    <th>Type</th>
                    <th>Image</th>
                    <th>Link</th>
                  </>
                )}
                {activeTab === "home_instagram_links" && <th>Post Code</th>}
                {activeTab !== "home_instagram_links" && <th>Status</th>}
                <th>Sort Order</th>
                <th colSpan={2}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>

                  {/* FAQs Column */}
                  {activeTab === "faqs" && <td>{item.question}</td>}

                  {/* Hero Slides Columns */}
                  {activeTab === "home_hero_slides" && (
                    <>
                      <td>
                        <img src={item.img} alt="slide" className="thumb-preview" />
                      </td>
                      <td>
                        <span
                          className="color-indicator"
                          style={{ background: item.color }}
                        ></span>
                        {item.color}
                      </td>
                      <td>{item.link}</td>
                    </>
                  )}

                  {/* Promo Banners Columns */}
                  {activeTab === "home_promo_banners" && (
                    <>
                      <td>
                        <strong style={{ textTransform: "uppercase" }}>{item.type}</strong>
                      </td>
                      <td>
                        <img src={item.img} alt="banner" className="thumb-preview" />
                      </td>
                      <td>{item.link}</td>
                    </>
                  )}

                  {/* Instagram Column */}
                  {activeTab === "home_instagram_links" && <td>{item.post_code}</td>}

                  {/* Status Column */}
                  {activeTab !== "home_instagram_links" && (
                    <td>
                      <span className={`status-badge ${item.status}`}>
                        {item.status}
                      </span>
                    </td>
                  )}

                  <td>{item.sort_order ?? 0}</td>

                  {/* Action Buttons */}
                  <td>
                    <button className="btn-edit" onClick={() => handleEditClick(item)}>
                      Edit
                    </button>
                    </td>
                    <td>
                    <button className="btn-delete" onClick={() => handleDelete(item.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


             </div>
        
        )}
      </div>
    </div>
  );
};

export default AdminHomePageManage;